import { useRef, useState } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { Play } from "lucide-react";

const POSTER = "/owner-poster.jpg";

export default function OwnerVideo() {
  const [playing, setPlaying] = useState(false);
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="owner" ref={ref} className="relative h-[80vh] overflow-hidden">
      {playing ? (
        <video
          data-testid="owner-video-player"
          src="/owner-message.mp4"
          poster={POSTER}
          autoPlay
          controls
          playsInline
          className="absolute inset-0 w-full h-full object-contain bg-ink"
        />
      ) : (
        <>
          <motion.div className="absolute inset-x-0 -top-[12%] h-[124%]" style={{ y: reduce ? 0 : y }} aria-hidden="true">
            <img src={POSTER} alt="" className="w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-ink/70" />
          </motion.div>

          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal mb-5">
              (04) — A word from the owner
            </p>
            <h2 className="font-display font-black uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
              The boss, in person.
            </h2>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400">
              Mr. Md Sadique · Owner
            </p>
            <button
              data-testid="owner-video-play"
              onClick={() => setPlaying(true)}
              aria-label="Play message from the owner"
              className="mt-12 group inline-flex items-center justify-center w-24 h-24 rounded-full bg-signal text-ink hover:scale-110 hover:shadow-[0_0_60px_rgba(255,90,0,0.55)] transition-all duration-300"
            >
              <Play size={30} fill="currentColor" className="ml-1" />
            </button>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-400">
              Play the message
            </p>
          </div>
        </>
      )}
    </section>
  );
}
